webpackJsonp([1,0,2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = exports.router = exports.app = undefined;
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(14);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(10);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(9);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueUa = __webpack_require__(11);
	
	var _vueUa2 = _interopRequireDefault(_vueUa);
	
	var _vuefire = __webpack_require__(13);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _firebase = __webpack_require__(6);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _App = __webpack_require__(33);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(37);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Video = __webpack_require__(42);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Facebook = __webpack_require__(35);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Help = __webpack_require__(36);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _Bpmn = __webpack_require__(34);
	
	var _Bpmn2 = _interopRequireDefault(_Bpmn);
	
	var _MovieTimesAndTickets = __webpack_require__(38);
	
	var _MovieTimesAndTickets2 = _interopRequireDefault(_MovieTimesAndTickets);
	
	var _Movies = __webpack_require__(39);
	
	var _Movies2 = _interopRequireDefault(_Movies);
	
	var _TV = __webpack_require__(41);
	
	var _TV2 = _interopRequireDefault(_TV);
	
	var _NewOnDVD = __webpack_require__(40);
	
	var _NewOnDVD2 = _interopRequireDefault(_NewOnDVD);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueUa2.default, {
	  appName: 'spinoff-vue',
	  appVersion: '0.1.0',
	  trackingId: 'UA-292579-4',
	  debug: true,
	  vueRouter: router,
	  ignoredViews: ['homepage'],
	  globalDimensions: [{ dimension: 1, value: 'MyDimensionValue' }, { dimension: 2, value: 'AnotherDimensionValue' }],
	  globalMetrics: [{ metric: 1, value: 'MyMetricValue' }, { metric: 2, value: 'AnotherMetricValue' }]
	});
	
	var NotFound = { template: '<p>Page not found</p>' };
	
	var store = new _vuex2.default.Store({
	  state: {
	    count: 0,
	    authUser: null
	  },
	  mutations: {
	    increment: function increment(state) {
	      state.count++;
	    }
	  }
	});
	
	var routes = [{ path: '/', component: _Home2.default }, { path: '/movie-times-and-tickets', component: _MovieTimesAndTickets2.default }, { path: '/movies', component: _Movies2.default }, { path: '/tv', component: _TV2.default }, { path: '/new-on-dvd', component: _NewOnDVD2.default }, { path: '/videos', component: _Video2.default }, { path: '/home', component: _Home2.default }, { path: '/facebook', component: _Facebook2.default }, { path: '/not_found', component: NotFound }, { path: '/help', component: _Help2.default }, { path: '/bpmn', component: _Bpmn2.default }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: routes
	});
	
	var firebaseApp = _firebase2.default.initializeApp({
	  apiKey: 'AIzaSyC0wPWhT1rpqnl_51nYNI_tsxb0Sz9WZNc',
	  authDomain: 'popping-inferno-7199.firebaseapp.com',
	  databaseURL: 'https://popping-inferno-7199.firebaseio.com',
	  storageBucket: 'popping-inferno-7199.appspot.com',
	  messagingSenderId: '1069734382415'
	
	});
	var db = firebaseApp.database();
	
	var app = new _vue2.default({
	  router: router,
	  firebase: {
	    anArray: db.ref('channels'),
	    anObject: {
	      source: db.ref('-KH3M8S6nitvLjccILhZ'),
	      asObject: true,
	      cancelCallback: function cancelCallback() {}
	    }
	  },
	  template: '<App />',
	  components: { App: _App2.default }
	}).$mount('#app');
	
	exports.app = app;
	exports.router = router;
	exports.store = store;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'sing-in',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(3),
	  /* template */
	  __webpack_require__(8),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui modal"
	  }, [_c('i', {
	    staticClass: "close icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n    Profile Picture\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "image content"
	  }, [_c('div', {
	    staticClass: "ui medium image"
	  }, [_c('img', {
	    attrs: {
	      "src": "https://semantic-ui.com/images/avatar2/large/rachel.png"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "description"
	  }, [_c('div', {
	    staticClass: "ui header"
	  }, [_vm._v("We've auto-chosen a profile image for you.")]), _vm._v(" "), _c('p', [_vm._v("We've grabbed the following image from the "), _c('a', {
	    attrs: {
	      "href": "https://www.gravatar.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("gravatar")]), _vm._v(" image associated with your registered e-mail address.")]), _vm._v(" "), _c('p', [_vm._v("Is it okay to use this photo?")])])]), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('div', {
	    staticClass: "ui black deny button"
	  }, [_vm._v("\n      Nope\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "ui positive right labeled icon button"
	  }, [_vm._v("\n      Yep, that's me\n      "), _c('i', {
	    staticClass: "checkmark icon"
	  })])])])
	}]}

/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SignIn = __webpack_require__(7);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: { SignIn: _SignIn2.default },
	  methods: {
	    showSingInModal: function showSingInModal() {
	      window.showSingInModal();
	    }
	  },
	  mounted: function mounted() {
	    window.$('#header-menu').dropdown({});
	  },
	  data: function data() {
	    return {
	      videos: []
	    };
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bpmn',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'facebook',
	  data: function data() {
	    return {
	      facebooks: [{
	        url: 'https://www.facebook.com/brightside/posts/1219086204886787'
	      }, {
	        url: 'https://www.facebook.com/cubebrush/videos/989872117781050/'
	      }, {
	        url: 'https://www.facebook.com/TheEpisodeApp/videos/679893675541296/'
	      }],
	      channels: [{
	        url: 'https://www.facebook.com/brightside'
	      }, {
	        url: 'https://www.facebook.com/cubebrush'
	      }, {
	        url: 'https://www.facebook.com/TheEpisodeApp'
	      }]
	    };
	  },
	
	  methods: {
	    reverseMessage: function reverseMessage() {
	      window.FB.XFBML.parse();
	    }
	  },
	  mounted: function mounted() {
	
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	      window.FB.XFBML.parse();
	    });
	  },
	  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {}
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'help',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'home',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'movie-times-and-tickets',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'movies',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'new-on-dvd',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'tv',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$root.$firebaseRefs.anObject.once('value', function (snapshot) {
	      window.console.log(snapshot.val());
	    });
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoListItem = __webpack_require__(44);
	
	var _VideoListItem2 = _interopRequireDefault(_VideoListItem);
	
	var _VideoItem = __webpack_require__(43);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _axios = __webpack_require__(16);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'video-page',
	  components: {
	    VideoListItem: _VideoListItem2.default,
	    VideoItem: _VideoItem2.default
	  },
	  data: function data() {
	    return {
	      page: 1,
	      videos: [],
	      currentVideo: {},
	      videoPlayerInfo: {
	        page: 1,
	
	        width: 550,
	        height: 310,
	        aspectRatio: '16:9',
	        keyword: ''
	      }
	    };
	  },
	
	  created: function created() {
	    this.pagination();
	  },
	  watch: {
	    currentVideo: function currentVideo() {},
	    page: function page(val) {
	      this.pagination();
	    }
	  },
	  mounted: function mounted() {
	    window.$('.menu .item').tab();
	    this.loadVideos();
	  },
	  updated: function updated() {},
	
	  methods: {
	    loadVideos: function loadVideos() {
	      var _this = this;
	
	      var self = this;
	      this.$http.get('/static/jsons/videos/' + self.page + '.json', {}).then(function (response) {
	        _this.videos = response.data.data;
	      });
	    },
	    setVideoItem: function setVideoItem(video) {
	      this.currentVideo = video;
	      window.FB.XFBML.parse();
	    },
	    pagination: function pagination() {
	      var self = this;
	      _axios2.default.get('/static/jsons/videos/' + self.page + '.json').then(function (response) {
	        self.videos = response.data.data;
	      }).catch(function (error) {
	        window.console.log(error);
	      });
	    }
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'video-item',
	  props: ['video'],
	  data: function data() {
	    return {
	      page: 1,
	      width: 480,
	      height: 270,
	      aspectRatio: '16:9',
	      keyword: ''
	    };
	  },
	  mounted: function mounted() {
	    this.width = document.documentElement.clientWidth;
	    this.height = this.width * (9 / 16);
	  },
	  updated: function updated() {
	    window.ga('send', 'event', 'see', 'vuejs', this.video_id);
	  },
	
	  methods: {}
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'video-list-item',
	  props: ['video'],
	  data: function data() {
	    return {
	      page: 1,
	      keyword: ''
	    };
	  },
	
	  methods: {
	    show: function show() {
	      this.$emit('setVideoItem', this.video);
	    }
	  }
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(32)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(18),
	  /* template */
	  __webpack_require__(54),
	  /* scopeId */
	  "data-v-6856f2b8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(19),
	  /* template */
	  __webpack_require__(55),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(49),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(21),
	  /* template */
	  __webpack_require__(53),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(51),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(23),
	  /* template */
	  __webpack_require__(46),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(24),
	  /* template */
	  __webpack_require__(56),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(25),
	  /* template */
	  __webpack_require__(52),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(26),
	  /* template */
	  __webpack_require__(47),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(30)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(27),
	  /* template */
	  __webpack_require__(45),
	  /* scopeId */
	  "data-v-0570acf9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(31)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(28),
	  /* template */
	  __webpack_require__(48),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(29),
	  /* template */
	  __webpack_require__(50),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui grid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "ui bottom attached active tab segment",
	    attrs: {
	      "data-tab": "list-panel"
	    }
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.page -= 1
	      }
	    }
	  }, [_vm._v("Before")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.page += 1
	      }
	    }
	  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
	    staticClass: "ui relaxed divided list"
	  }, _vm._l((_vm.videos), function(video, index) {
	    return _c('video-list-item', {
	      attrs: {
	        "video": video
	      },
	      on: {
	        "setVideoItem": _vm.setVideoItem
	      }
	    })
	  })), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.page -= 1
	      }
	    }
	  }, [_vm._v("Before")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.page += 1
	      }
	    }
	  }, [_vm._v("Next")])]), _vm._v(" "), _c('div', {
	    staticClass: "ui bottom attached tab segment",
	    attrs: {
	      "data-tab": "player-panel"
	    }
	  }, [_c('video-item', {
	    attrs: {
	      "video": _vm.currentVideo
	    }
	  })], 1), _vm._v(" "), (_vm.currentVideo.video_id) ? _c('div', {
	    attrs: {
	      "id": "video-player"
	    }
	  }, [_c('iframe', {
	    attrs: {
	      "width": _vm.videoPlayerInfo.width,
	      "height": _vm.videoPlayerInfo.height,
	      "src": '//www.youtube.com/embed/' + _vm.currentVideo.video_id,
	      "frameborder": "0",
	      "allowfullscreen": "false"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "fb-comments",
	    attrs: {
	      "data-href": 'https://spinoff.cloudhomez.com/' + _vm.currentVideo.video_id,
	      "data-numposts": "5"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui top attached tabular menu"
	  }, [_c('a', {
	    staticClass: "active item",
	    attrs: {
	      "data-tab": "list-panel"
	    }
	  }, [_vm._v("List")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    attrs: {
	      "data-tab": "player-panel"
	    }
	  }, [_vm._v("Player")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    attrs: {
	      "data-tab": "description-panel"
	    }
	  }, [_vm._v("Description")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui bottom attached tab segment",
	    attrs: {
	      "data-tab": "description-panel"
	    }
	  }, [_c('div', {}, [_vm._v("Video Description")])])
	}]}

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Movie Times & Tickets")])])
	}]}

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("TV")])])
	}]}

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "player-layer"
	    }
	  }, [(_vm.video.video_id) ? _c('iframe', {
	    attrs: {
	      "width": _vm.width,
	      "height": _vm.height,
	      "src": '//www.youtube.com/embed/' + _vm.video.video_id,
	      "frameborder": "0",
	      "allowfullscreen": "false"
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
	    staticClass: "ui stackable three column grid"
	  }, _vm._l((_vm.channels), function(channel) {
	    return _c('div', {
	      staticClass: "fb-page",
	      attrs: {
	        "data-href": channel.url,
	        "data-tabs": "timeline",
	        "data-small-header": "true",
	        "data-adapt-container-width": "false",
	        "data-hide-cover": "false",
	        "data-show-facepile": "false"
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    staticClass: "ui stackable two column grid"
	  }, _vm._l((_vm.facebooks), function(facebook) {
	    return _c('div', [_c('div', {
	      staticClass: "column fb-post",
	      attrs: {
	        "data-href": facebook.url,
	        "data-show-text": "true"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "fb-comments",
	      attrs: {
	        "data-href": facebook.url,
	        "data-numposts": "5"
	      }
	    })])
	  }))])
	},staticRenderFns: []}

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('a', {
	    staticClass: "header",
	    attrs: {
	      "href": '//www.youtube.com/channel/' + _vm.video.channel_id,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.video.channel_title))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "extra"
	  }, [_c('a', {
	    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
	    attrs: {
	      "hrxef": 'https://youtu.be/' + _vm.video.video_id,
	      "target": "_blank"
	    },
	    on: {
	      "click": _vm.show
	    }
	  }, [_vm._v(_vm._s(_vm.video.title))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image"
	  }, [_c('i', {
	    staticClass: "material-icons mdl-list__item-avatar"
	  }, [_vm._v("person")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "meta"
	  }, [_c('span', [_vm._v("Description")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "description"
	  }, [_c('p')])
	}]}

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "home"
	    }
	  }, [_c('div', {
	    staticClass: "ui vertical stripe segment"
	  }, [_c('div', {
	    staticClass: "ui text container"
	  }, [_c('h1', {
	    staticClass: "ui inverted header"
	  }, [_vm._v("\n        SpinfOff\n      ")]), _vm._v(" "), _c('h2', [_vm._v("Do whatever you want when you want to.")]), _vm._v(" "), _c('div', {
	    staticClass: "ui huge primary button"
	  }, [_vm._v("Get Started "), _c('i', {
	    staticClass: "right arrow icon"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "ui middle aligned stackable grid container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "eight wide column"
	  }, [_c('h3', {
	    staticClass: "ui header"
	  }, [_vm._v("We Help Companies and Companions")]), _vm._v(" "), _c('p', [_vm._v("We can give your company superpowers to do things that they never thought possible. Let us delight your customers and empower your needs...through pure data analytics.")]), _vm._v(" "), _c('h3', {
	    staticClass: "ui header"
	  }, [_vm._v("We Make Bananas That Can Dance")]), _vm._v(" "), _c('p', [_vm._v("Yes that's right, you thought it was the stuff of dreams, but even bananas can be bioengineered.")])]), _vm._v(" "), _c('div', {
	    staticClass: "six wide right floated column"
	  }, [_c('img', {
	    staticClass: "ui large bordered rounded image",
	    attrs: {
	      "src": "static/semantic-ui/examples/assets/images/wireframe/white-image.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "center aligned column"
	  }, [_c('a', {
	    staticClass: "ui huge button"
	  }, [_vm._v("Check Them Out")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "ui vertical stripe quote segment"
	  }, [_c('div', {
	    staticClass: "ui equal width stackable internally celled grid"
	  }, [_c('div', {
	    staticClass: "center aligned row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h3', [_vm._v("\"What a Company\"")]), _vm._v(" "), _c('p', [_vm._v("That is what they all say about us")])]), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('h3', [_vm._v("\"I shouldn't have gone with their competitor.\"")]), _vm._v(" "), _c('p', [_c('img', {
	    staticClass: "ui avatar image",
	    attrs: {
	      "src": "static/semantic-ui/examples/assets/images/avatar/nan.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("Nan")]), _vm._v(" Chief Fun Officer Acme Toys\n          ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "ui vertical stripe segment"
	  }, [_c('div', {
	    staticClass: "ui text container"
	  }, [_c('h3', {
	    staticClass: "ui header"
	  }, [_vm._v("Breaking The Grid, Grabs Your Attention")]), _vm._v(" "), _c('p', [_vm._v("Instead of focusing on content creation and hard work, we have learned how to master the art of doing nothing by providing massive amounts of whitespace and generic content that can seem massive, monolithic and worth your attention.")]), _vm._v(" "), _c('a', {
	    staticClass: "ui large button"
	  }, [_vm._v("Read More")]), _vm._v(" "), _c('h4', {
	    staticClass: "ui horizontal header divider"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Case Studies")])]), _vm._v(" "), _c('h3', {
	    staticClass: "ui header"
	  }, [_vm._v("Did We Tell You About Our Bananas?")]), _vm._v(" "), _c('p', [_vm._v("Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but its really true. It took years of gene splicing and combinatory DNA research, but our bananas can really dance.")]), _vm._v(" "), _c('a', {
	    staticClass: "ui large button"
	  }, [_vm._v("I'm Still Quite Interested")])])])])
	}]}

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("NewOnDVD")])])
	}]}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Help")]), _vm._v(" "), _c('iframe', {
	    attrs: {
	      "src": "http://www.bpmnquickguide.com/quickguide/",
	      "scrolling": "auto",
	      "frameborder": "0",
	      "width": "100%",
	      "height": "700px"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('sign-in'), _vm._v(" "), _c('div', {
	    staticClass: "ui fixed inverted menu"
	  }, [_c('div', {
	    staticClass: "ui dropdown icon item",
	    attrs: {
	      "id": "header-menu"
	    }
	  }, [_c('i', {
	    staticClass: "sidebar icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "menu"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("Main")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/movie-times-and-tickets"
	    }
	  }, [_vm._v("Movie Times & Tickets")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/movies"
	    }
	  }, [_vm._v("Movies")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/tv"
	    }
	  }, [_vm._v("TV")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/new-on-dvd"
	    }
	  }, [_vm._v("New On DVD")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/facebook"
	    }
	  }, [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
	    staticClass: "header"
	  }, [_vm._v("Support")]), _vm._v(" "), _c('div', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/help"
	    }
	  }, [_vm._v("Help")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/bpmn",
	      "target": "_blank"
	    }
	  }, [_vm._v("BPMN")])], 1)]), _vm._v(" "), _c('router-link', {
	    staticClass: "active item",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": "/videos"
	    }
	  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
	    staticClass: "right menu"
	  }, [_vm._m(0), _vm._v(" "), _c('a', {
	    staticClass: "ui item"
	  }, [_vm._v("\n        Logout\n      ")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    on: {
	      "click": _vm.showSingInModal
	    }
	  }, [_vm._v("Sing In")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    on: {
	      "click": _vm.showSingInModal
	    }
	  }, [_vm._v("Sing Up")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "ui main text container"
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui right aligned category search item"
	  }, [_c('div', {
	    staticClass: "ui inverted transparent icon input"
	  }, [_c('input', {
	    staticClass: "prompt",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search keyword..."
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "search link icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "results"
	  })])
	}]}

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "bpmn-container"
	    }
	  }, [_c('h3', [_vm._v("Bpmn")]), _vm._v(" "), _c('iframe', {
	    attrs: {
	      "src": "http://www.bpmnquickguide.com/quickguide/",
	      "scrolling": "auto",
	      "frameborder": "0",
	      "width": "100%",
	      "height": "700px"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Movies")])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.4896cfcb589051a57425.js